var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"upload",attrs:{"for":"uploadImage"},on:{"click":_vm.clickFile}},[_c('i',{staticClass:"el-icon-picture-outline"}),_c('input',{ref:"imgDom",staticClass:"hide",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.pictureChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }